(function () {
  var activated = false;
  function reviveScripts(container) {
    container.querySelectorAll('script').forEach(function (old) {
      var s = document.createElement('script');
      for (var i = 0; i < old.attributes.length; i++) {
        var a = old.attributes[i];
        s.setAttribute(a.name, a.value);
      }
      s.textContent = old.textContent;
      old.replaceWith(s);
    });
  }
  function activate() {
    if (activated) return;
    activated = true;
    document.querySelectorAll('[data-lazy-shop-login]').forEach(function (el) {
      var tmp = document.createElement('div');
      tmp.innerHTML = el.textContent;
      reviveScripts(tmp);
      var nodes = Array.prototype.slice.call(tmp.childNodes);
      if (nodes.length) el.replaceWith.apply(el, nodes);
      else el.remove();
    });
    document.removeEventListener('mouseover', onTrigger);
    document.removeEventListener('touchstart', onTrigger);
    document.removeEventListener('focusin', onTrigger);
  }
  function onTrigger(e) {
    if (e.target.closest && e.target.closest('.header-customer-accounts, .menu-drawer')) {
      activate();
    }
  }
  document.addEventListener('mouseover', onTrigger);
  document.addEventListener('touchstart', onTrigger, { passive: true });
  document.addEventListener('focusin', onTrigger);
  var idle = window.requestIdleCallback || function (cb) { setTimeout(cb, 3000); };
  idle(activate, { timeout: 5000 });
})();
